import type { Dispatch, SetStateAction } from "react";
import { t } from "@/i18n-js/instance";
import type { MarketingEmailTemplateContentType } from "@/react/types/MarketingEmailTemplates";
import { Modal } from "@circle-react-uikit/ModalV2";
import { Sidebar } from "./Sidebar";
import { useNavigation } from "./Sidebar/useNavigation";
import { TemplateContents } from "./TemplateContents";
import type { SelectedCategory } from "./TemplateContents";
import type { ContentType } from "./TemplateContents/TemplateFilter";

const localeNamespace = "settings.emails.templates";

export const ListTemplatesV2 = ({
  onClose,
  onApply,
  selectedCategory,
  onSelectCategory,
  contentType,
  onChangeContentType,
}: {
  onClose: () => void;
  onApply: (
    templateId: number,
    contentType: MarketingEmailTemplateContentType,
  ) => void;
  selectedCategory: SelectedCategory;
  onSelectCategory: (id: SelectedCategory) => void;
  contentType: ContentType;
  onChangeContentType: Dispatch<SetStateAction<ContentType>>;
}) => {
  const { activeId, navigationItems, onClickNavItem } = useNavigation({
    selectedCategory,
    onSelectCategory,
    onResetContentType: () => onChangeContentType("all"),
  });

  return (
    <>
      <div className="border-b-primary text-dark flex items-center justify-between border-b px-8 pb-5 pt-6">
        <Modal.Title size="sm">
          {t([localeNamespace, "template_library"])}
        </Modal.Title>
        <Modal.CloseButton onClick={onClose} />
      </div>
      <Modal.Body className="flex !p-0">
        <Sidebar
          activeId={activeId}
          navigationItems={navigationItems}
          onClickNavItem={onClickNavItem}
        />
        <TemplateContents
          selectedCategory={activeId}
          onApply={onApply}
          contentType={contentType}
          setContentType={onChangeContentType}
        />
      </Modal.Body>
    </>
  );
};
